import { useEffect } from "react";
import "./App.css";
import RouterContainer from "./router_container/RouterContainer";

function App() {

  return <RouterContainer />;
}

export default App;
